// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2IcJr","log":"ModalInventoryLogs_log__1Q5QT","date":"ModalInventoryLogs_date__14xR-","userName":"ModalInventoryLogs_userName__qBOmm"};